import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withCookies } from "react-cookie";
import { withRouter } from "react-router-dom";
import ApiClient from "../../Client";

const { REACT_APP_IDENTITY_COOKIE: IDENTITY_COOKIE } = process.env;

const mapStateToProps = ({ identity }) => ({
  identity
});

class PasswordForm extends Component {
  state = {
    oldPassword: "",
    password: "",
    passwordRepeat: "",
    errors: {},
    errorSummary: ""
  };

  componentWillUnmount() {
    this.isCancelled = true;
  }

  getAuthKey() {
    const { cookies } = this.props;
    return cookies.get(IDENTITY_COOKIE) || "";
  }

  onChangeInput = (name, value) => {
    this.setState({ [name]: value }, () => {
      this.hasErrors(name) && this.validate(name);
    });
  };

  setError(name, message) {
    this.addErrors({ [name]: message });
  }

  getError(name) {
    return this.state.errors[name] || null;
  }

  addErrors(errors) {
    this.setState({ errors: { ...this.state.errors, ...errors } });
  }

  hasErrors(name = null) {
    const { errors } = this.state;
    return !!(name ? errors[name] : Object.entries(errors).length);
  }

  validate(attributes = null, refresh = true) {
    const errors = refresh ? {} : this.state.errors;
    const { oldPassword, password, passwordRepeat } = this.state;
    if (attributes && !Array.isArray(attributes)) {
      attributes = [attributes];
    }

    if ((!attributes || attributes.includes("oldPassword")) && !oldPassword) {
      errors["oldPassword"] = "Field 'old password' is required";
    }

    if ((!attributes || attributes.includes("password")) && !password) {
      errors["password"] = "Field 'password' is required";
    }

    if (
      (!attributes || attributes.includes("passwordRepeat")) &&
      !passwordRepeat
    ) {
      errors["passwordRepeat"] = "Field 'password repeat' is required";
    }

    if (!attributes || attributes.includes("passwords")) {
      if (password && passwordRepeat && password !== passwordRepeat) {
        errors["passwords"] = "Passwords do not match";
      }
    }

    !attributes
      ? this.setState({ errors })
      : this.addErrors(
          attributes.reduce(
            (prev, attribute) =>
              Object.assign(prev, { [attribute]: errors[attribute] || null }),
            {}
          )
        );
    return !Object.entries(errors).length;
  }

  getRefreshAuthUrl() {
    const {
      REACT_APP_AUTH_HOST: AUTH_HOST,
      REACT_APP_DOMAIN: DOMAIN
    } = process.env;
    const redirectUrl = "//" + encodeURIComponent(DOMAIN);
    console.log(`${AUTH_HOST}/auth/refresh?redirect-url=${redirectUrl}`);
    return `${AUTH_HOST}/auth/refresh?redirect-url=${redirectUrl}`;
  }

  submit = () => {
    if (this.validate()) {
      const { oldPassword, password } = this.state;
      const authKey = this.getAuthKey();
      !this.isCancelled &&
        ApiClient.setHeader("authKey", authKey)
          .request(
            "mutation($oldPassword: String! $password: String!){changePassword(oldPassword:$oldPassword password:$password){id}}",
            { oldPassword, password }
          )
          .then(
            ({ changePassword }) =>
              !this.isCancelled &&
              changePassword &&
              changePassword.id &&
              (window.location = this.getRefreshAuthUrl())
          )
          .catch(e => {
            console.log(e);
            !this.isCancelled &&
              this.setState({ errorSummary: "Invalid password" });
          });
    }
  };

  renderError(name) {
    if (this.hasErrors(name)) {
      return <span className="text-danger">{this.getError(name)}</span>;
    }
    return "";
  }

  renderInput(
    name,
    label,
    groupProps = {},
    inputProps = {},
    defaultValue = ""
  ) {
    if (!groupProps.className) {
      groupProps.className = "office-form__group";
    }
    const value = this.state[name] || defaultValue;
    const hasError = this.hasErrors(name) || null;
    if (hasError) {
      groupProps.className += " has-error";
    }
    let component = "input";
    if (inputProps.component) {
      component = inputProps.component;
      delete inputProps.component;
    }
    if (!inputProps.id) {
      inputProps.id = `${name}-input`;
    }
    if (!inputProps.onChange) {
      inputProps.onChange = e => this.onChangeInput(name, e.target.value);
    }
    return (
      <div {...groupProps}>
        <label htmlFor={inputProps.id}>{label}</label>
        {React.createElement(component, { value, ...inputProps })}
        {hasError && <span className="text-danger">{this.getError(name)}</span>}
      </div>
    );
  }

  onOldPasswordChange = e => {
    this.setState({ oldPassword: e.target.value, errorSummary: "" }, () => {
      this.hasErrors("oldPassword") && this.validate("oldPassword");
    });
  };

  render() {
    const { errorSummary } = this.state;
    const passwordsError = this.renderError("passwords");
    return (
      <Fragment>
        <h1 className="office-h1">Сменить пароль</h1>
        <div className="office-form office-form_white">
          {this.renderInput(
            "oldPassword",
            "Старый пароль",
            { className: "office-form__group required" },
            {
              placeholder: "Старый пароль",
              type: "password",
              onChange: this.onOldPasswordChange
            }
          )}

          <div className="office-form__union-2">
            {this.renderInput(
              "password",
              "Новый пароль",
              { className: "office-form__group required" },
              { placeholder: "Новый пароль", type: "password" }
            )}
            {this.renderInput(
              "passwordRepeat",
              "Подтверждение нового пароля",
              { className: "office-form__group required" },
              { placeholder: "Подтверждение нового пароля", type: "password" }
            )}
          </div>
          {passwordsError && (
            <Fragment>
              <br />
              {passwordsError}
            </Fragment>
          )}
          {errorSummary && (
            <Fragment>
              <br />
              <span className="text-danger">{errorSummary}</span>
            </Fragment>
          )}
          <hr />
          <div>
            <button className="btn-gradient" onClick={this.submit}>
              Сохранить
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withCookies(withRouter(connect(mapStateToProps)(PasswordForm)));



// WEBPACK FOOTER //
// ./src/containers/user/passwordForm.jsx